import { useEffect, useState } from 'react';
import useSWR from 'swr';
import getAuthClient from 'Tasking_Helpers/getAuthClient';

const memberInfoUrl = 'v5/members';
const options = {
  revalidateOnFocus: false,
};

const getMemberInfo = async (url) => {
  const authorizedApiClient = await getAuthClient();

  if (authorizedApiClient) {
    return await authorizedApiClient.get(url);
  }
};

const useMemberHistory = (initUserId) => {
  const [isPending, setIsPending] = useState(true);
  const [memberHistory, setMemberHistory] = useState();
  const [userId, setUserId] = useState(initUserId);
  const {
    data: memberHistoryResult,
    error,
    mutate,
  } = useSWR(() => (userId ? `${process.env.API_BASE_URL}/${memberInfoUrl}/${userId}/history` : ''), getMemberInfo, {
    ...options,
  });

  useEffect(() => {
    if (memberHistoryResult) {
      setMemberHistory(memberHistoryResult.data);
    }

    setIsPending(!memberHistoryResult && !error);
  }, [memberHistoryResult, error]);

  const retrieveMemberHistory = (newUserId) => {
    if (!newUserId) return;
    setUserId(newUserId);
    mutate(userId);
  };

  return { memberHistory, error, isPending, retrieveMemberHistory };
};

export default useMemberHistory;
